import { Component, OnInit, OnDestroy } from '@angular/core';
import { BaseService } from '../services/base.service';
import { Http} from '@angular/http';
import { ISeasonWeek } from '../models/ISeasonWeek';
import { AdminService } from '../services/admin.service';
import { NflService } from '../services/nfl.service';
import { IOrg } from '../models/IOrg';
import { FormGroup } from '@angular/forms'
import { AuthService } from '../account/auth.service';
import { IGame } from '../models/IGame';
import { ITeam } from '../models/ITeam';
import { OrgSeasonWeekService } from '../services/orgseasonweek.service';
import { IOrgSeasonWeek } from '../models/IOrgSeasonWeek';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-nfl',
  templateUrl: './nfl.component.html',
  styleUrls: ['./nfl.component.scss']
})
export class NflComponent implements OnInit, OnDestroy {

  public isRequesting: boolean = false;

  //public model: IGame;
  public games: IGame[];
  public orgs: IOrg[];
  // public tieBreaker: number;
  public selectedOrg: IOrg;
  public seasonWeeks: ISeasonWeek[] = []
  public isHomeFavorite: boolean;

  public disabled: boolean = false;
  public localTime: string;
  public serverStartDateTime: Date;
  public error: any;
  public form: FormGroup;
  public model: IOrgSeasonWeek = { season: null, seasonType: null, week: null, org: null };

  constructor(private adminService: AdminService,
    private authService: AuthService,
    private nflService: NflService,
    private baseService: BaseService,
    private orgSeasonWeekService: OrgSeasonWeekService
  ) {
  }
  public orgEvent: Subscription;
  public weekEvent: Subscription;
  public seasonEvent: Subscription;
  ngOnInit() {

    //this.orgs = this.authService.orgs;
    this.model.userId = this.authService.user.id;
    this.orgEvent = this.orgSeasonWeekService.org.subscribe(org => {
      this.model.org = org;
      this.weekEvent = this.orgSeasonWeekService.season.subscribe(season => {
        this.model.season = season;
        this.seasonEvent = this.orgSeasonWeekService.week.subscribe(week => {
          this.model.week = week;
          this.nflService.getUserGames(this.model).subscribe(result => {
            this.games = result as IGame[];
            this.games.sort((a, b) => this.baseService.getEpochTime(a.startDateTime) - this.baseService.getEpochTime(b.startDateTime));
          });
        });
      });
    });
  }

  ngOnDestroy(): void {
    this.orgEvent.unsubscribe();
    this.seasonEvent.unsubscribe();
    this.weekEvent.unsubscribe();
  }

  changeSelected(game: IGame, team: ITeam) {
    if (this.baseService.isBeforeNow(game.startDateTime)) {
      this.baseService.toasterService.pop('error', 'Football User', 'Game has already started');
      game.locked = true;
    }
    else {
      game.selected = team;
      this.updateOrgUserGame(game);
      this.baseService.toasterService.pop('info', 'Football User', 'Pick changed to ' + game.selected.name);
    }
  }
  
  settCurrentOrg(org: IOrg) {
    this.selectedOrg = org;
  }


  updateTieBreaker(game: IGame) {
    //var game = this.games.slice(-1)[0] as IGame;
    if (this.baseService.isBeforeNow(game.startDateTime)) {
      this.baseService.toasterService.pop('error', 'Football User', 'Tie Breaker Game has already Started');
      game.locked = true;
    }
    else {
      //game.tieBreaker = event.target.value;
      this.updateOrgUserGame(game)
      this.baseService.toasterService.pop('info', 'Football User', 'Tie Breaker changed to ' + game.tieBreaker);
    }
  }

  updateOrgUserGame(game: IGame) {
    //game.orgId = this.selectedOrg.id;
    this.nflService.updateOrgUserGame(game).subscribe();
    // this.nflService.updateOrgGame(game).unsubscribe
  }

  localtime(gamestart: any) {
    return this.baseService.getLocalTimeFromUtc(gamestart);
  }

  allCapsFavorite(game: IGame) {
    if (game.favorite.name == game.home.name) {
      return game.favorite.name.toUpperCase();
    }
    else
      return game.favorite.name
  }
  allCapsUnderdog(game: IGame) {
    if (game.underdog.name == game.home.name) {
      return game.underdog.name.toUpperCase();
    }
    else
      return game.underdog.name
  }

  winner(status: string, points: number) {
    if (points > 0)
      return true;
    else
      return false;
  }


}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/nfl/nfl.component.ts